import { makeDefaultApi, requestRaw } from './request';
import { CountryData } from './countries';
import { UserData } from './users';
import { I18nText } from '../i18n_text';
import { UserLogMixinData } from './changelog';

export interface OrganizationTypeData extends UserLogMixinData {
  id: string;
  name_json: I18nText;
  public: boolean;
  use_for_breeders: boolean;
  use_for_producers: boolean;
  use_for_customers: boolean;
}

interface OrganizationTypeFilters {
  ids?: string[];
  use_for_breeders?: boolean;
  use_for_producers?: boolean;
  use_for_customers?: boolean;
}

export const organizationTypesApi = makeDefaultApi<OrganizationTypeData, OrganizationTypeFilters>(
  'organization_types'
);

export interface OrganizationData extends UserLogMixinData {
  id: string;
  name: string;
  country: CountryData;
  contact: string;
  address: string;
  phone: string;
  email: string;
  responsible: UserData;
  organization_type: OrganizationTypeData;
  users_emails: string[];
}

export interface BreederData extends OrganizationData {}

export interface BuyerData extends OrganizationData {}

export interface ProducerData extends OrganizationData {}

export interface CustomerData extends OrganizationData {}

export interface PartnerData extends OrganizationData {}

/** What the five organization list endpoints take, beyond the shared list parameters. */
export interface OrganizationListParams {
  country_id?: string;
  restrict_country?: boolean;
  ids?: string[];
  archived?: boolean;
  /** The React table's filter model, serialised, and its sort keys. */
  filter?: string;
  sort?: string[];
}

export const breedersApi = makeDefaultApi<BreederData, OrganizationListParams>('breeders');
export const buyersApi = makeDefaultApi<BuyerData, OrganizationListParams>('buyers');
export const producersApi = makeDefaultApi<ProducerData, OrganizationListParams>('producers');
export const customersApi = makeDefaultApi<CustomerData, OrganizationListParams>('customers');
export const partnersApi = makeDefaultApi<PartnerData, OrganizationListParams>('partners');

export function downloadOrganizationsImportTemplate(
  type: 'breeders' | 'customers' | 'partners'
): Promise<Blob> {
  return requestRaw('GET', `/api/${type}/import_template/`);
}
